import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "..";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const getAllPersons = active => {
  return dispatch => {
    dispatch({ type: "GET_ALL_PERSONS_LOADING" });
    const personsPromise = active ? api.personsGetActive() : api.personsGetAll();

    personsPromise.then(resp => {
      dispatch(operationSucceeded(resp.data));
      dispatch({ type: "GET_ALL_PERSONS_LOADING_DONE" });
    })
      .catch(e => {
        jsError(e);
        dispatch({ type: "GET_ALL_PERSONS_LOADING_DONE" });
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "SearchPersonsErrorAlertTitle",
          "Virhe henkilöiden haussa",
          (e.response && e.response.data) && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "GET_ALL_PERSONS_SUCCEEDED",
  payload: { persons: data },
});

const operationFail = () => ({
  type: "GET_ALL_PERSONS_FAIL",
});
